import { Component, computed, EnvironmentInjector, inject, OnDestroy, signal } from '@angular/core';
import { IonTabs, IonTabBar, IonTabButton, IonIcon, IonLabel } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { search, cart, person, homeSharp } from 'ionicons/icons';
import { CheckoutButtonComponent } from '../components/primitives/checkout-button/checkout-button.component';
import { UiService } from '../services/ui.service';
import { StateService } from '../services/state.service';
import { Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { AmplitudeService } from '../services/amplitude.service';
import { OnStartupModalComponent } from "../components/elements/on-startup-modal/on-startup-modal.component";
import { NativeService } from '../services/native.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-tabs',
    templateUrl: 'tabs.page.html',
    styleUrls: ['tabs.page.scss'],
    imports: [CommonModule, IonTabs, IonTabBar, IonTabButton, IonIcon, IonLabel, CheckoutButtonComponent, OnStartupModalComponent],
})
export class TabsPage implements OnDestroy {
  private $amplitude = inject(AmplitudeService);
  private $state = inject(StateService);
  private $native = inject(NativeService);
  private $ui = inject(UiService);
  private router = inject(Router);
  public environmentInjector = inject(EnvironmentInjector);

  private orders = toSignal(this.$state.bOrders);
  private cart = toSignal(this.$state.bCart);

  public isLoggedIn = this.$state.isLoggedIn;
  public isWeb = this.$native.isWeb;
  public hasAddress = this.$state.hasAddress;

  private subscriptions: Subscription[] = [];

  public cartVisible = computed<boolean>(() => this.combinedItemCount() > 0);
  public combinedItemCount = computed<number>(() => this.cart()?.combinedItemCount ?? 0);
  public activeOrderCount = computed<number>(() => this.orders()?.filter(order => !['Cancelled', 'Completed', 'Delivered'].includes(order.status!)).length ?? 0);

  constructor() {
    addIcons({ homeSharp, search, cart, person });
    this.subscriptions.push(
      this.$ui.addPrescriptionsFromCart.subscribe(() => {
        this.$amplitude.track('CART_ADD_SCRIPT');
        this.openScriptWallet();
      })
    );

    this.subscriptions.push(
      this.$ui.addOTCItemsFromCart.subscribe(() => {
        this.$amplitude.track('CART_ADD_OTC_ITEM');
        this.addCartItems();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  public showCart(): void {
    this.$ui.showCartCheckout.next();
  }

  public openScriptWallet(): void {
    this.router.navigate(['/tabs/my-scripts']);
  }

  public addCartItems(): void {
    this.router.navigate(['/tabs/browse']);
  }
}